<template>
  <div>
    <modal ref="timermodal">
      <div slot="title" v-translate>Časovač</div>
      <div slot="body" v-translate>
        Počet vteřin zobrazení oznámení před možností potvrdit přečtení.
      </div>
    </modal>
    <section>
      <div class="left">
        <h2 v-translate>Základní informace</h2>
      </div>

      <div class="right">

        <div class="field_left">
          <p class="message_settings">
            {{ this.$gettext('Typ oznámení') }}:
            <span>{{ type }}</span>
          </p>
          <p class="message_settings">
            {{ this.$gettext('Označit za přečtené v') }}:
            <span v-if="entity.time_validity !== null">{{ entity.time_validity }}</span>
            <span v-else>{{ this.$gettext('Ne') }}</span>
          </p>
          <p class="message_settings">
            {{ this.$gettext('Počet příjemců') }}:
            <span>{{ entity.recipients_count }}</span>
          </p>
          <p class="message_settings">
            {{ this.$gettext('Datum odeslání') }}:
            <span>{{ $_date_formatFull(entity.date_created, false) }}</span>
          </p>
        </div>

        <div class="field_right">
          <p class="message_settings">
            {{ this.$gettext('Vynucení potvrzení') }}:
            <span v-if="forceConfirmation">{{ this.$gettext('Ano') }}</span>
            <span v-else>{{ this.$gettext('Ne') }}</span>
          </p>
          <p class="message_settings">
            {{ this.$gettext('Časovač') }}
            <img @click.stop="$refs.timermodal.showModal(true)" class="is_set" src="../../../../assets/images/info.svg"/>:
            <span v-if="entity.timer !== null">{{ entity.timer }} {{ this.$gettext('sec') }}</span>
            <span v-else>{{ this.$gettext('Ne') }}</span>
          </p>

          <p class="message_settings">
            {{ this.$gettext('Vytvořil') }}:
            <span>{{ entity.user_created }}</span>
          </p>

          <p class="message_settings">
            {{ this.$gettext('Operátor') }}:
            <span>{{ entity.operator_name }}</span>
          </p>
        </div>

      </div>

    </section>
    <section>
      <div class="left">

      </div>

      <div class="left">
        <div class="field">
          <select-box id="translationLanguage"
                      v-model="translation.language"
                      :options="languagesToSelect"
                      @input="selectLanguage"
          />
        </div>
      </div>
      <div class="right">
        <div class="field">
          <text-input id="translationSubject"
                      v-model="translation.subject"
                      name="translationSubject"
                      ref="translationsubjectref"
                      size="30"
                      :disabled="true"
                      max-length="50"
          >
            <translate class="translate">Nadpis oznámení</translate>
          </text-input>
        </div>

        <p class="field">
          <text-input
              id="translationShortBody"
              name="translationShortBody"
              v-model="translation.short_body"
              ref="translationshortbodyref"
              :disabled="true"
              max-length="255"
          >
            <translate class="translate">Zkrácená verze oznámení</translate>
          </text-input>
        </p>

        <p class="field">
          <html-editor
              v-if="translation.body"
              id="translationBody"
              name="translationBody"
              :custom-toolbar="customToolbar"
              :body="translation.body"
              ref="translationbodyref"
              @newVal="translation.body = arguments[0]"
              :disabled="true">
            <translate class="translate">Tělo oznámení</translate>
          </html-editor>
        </p>
      </div>
    </section>
  </div>
</template>

<script>

import HtmlEditor from "../../../common/HtmlEditor"
import modal from "../../../common/Modal.vue";
import types from "../mixins/types"

export default {
  name: "MessageBasicInfo",
  components: {HtmlEditor, modal},
  mixins: [types],
  props: {
    entity: Object,
  },
  data() {
    return {
      translation: {
        language: this.$language.current,
        subject: '',
        short_body: '',
        body: ''
      },
      customToolbar: [[]], // no toolbar for disabled editor
    }
  },
  created() {

  },
  watch: {
    entity: function (newVal, oldVal) {
      this.translation.language = Object.keys(newVal.translations)[0]
      this.selectLanguage()
    }
  },
  computed: {
    messageTypeOptions() {
      return [
        {id: 'info', text: this.$gettext('Informativní sdělení')},
        {id: 'maintenance_info', text: this.$gettext('Servisní informace')},
        {id: 'new_service', text: this.$gettext('Nová služba')},
        {id: 'fault', text: this.$gettext('Porucha')},
        {id: 'maintenance', text: this.$gettext('Servis')},
        {id: 'billing', text: this.$gettext('Platby')},
      ]
    },
    type: {
      get() {
        let type = this.messageTypeOptions.find(o => o.id === this.entity.type)
        return (type && type.hasOwnProperty("text")) ? type.text : null;
      }
    },
    languagesToSelect() {
      let languages = []
      for (let key in this.entity.translations) {
        languages.push({id: key.toLowerCase(), text: key})
      }
      return languages
    },
    forceConfirmation() {
      return this.entity.force_confirmation
    }
  },
  methods: {
    selectLanguage() {
      let tempTranslation = this.entity.translations[this.translation.language]
      this.translation.subject = tempTranslation.subject
      this.translation.short_body = tempTranslation.short_body
      this.translation.body = tempTranslation.body
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/messages/settings/MessageBasicInfo.vue